// app/javascript/controllers/print_controller.js
import { Controller } from "@hotwired/stimulus"

// 印刷ダイアログを開く(インライン JS を使わないため)
export default class extends Controller {
  print(event) {
    event.preventDefault()
    window.print()
  }
}
